import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { environment } from '../../../environment';
import { AoiService } from '../../../services/aoi.service';
import { GisToolsService } from '../../../services/gis-tools.service';
import { BaseComponent } from '../../base.component';
/* tslint:disable:template-cyclomatic-complexity */
var RegionComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RegionComponent, _super);
    function RegionComponent(_vcr, gisToolsService, aoiService, cdr, authService, loggingService, userSettingsService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.gisToolsService = gisToolsService;
        _this.aoiService = aoiService;
        _this.cdr = cdr;
        _this.authService = authService;
        _this.loggingService = loggingService;
        _this.userSettingsService = userSettingsService;
        _this.SUPPORTED_DEFAULT_REGIONS = ['county', 'district'];
        _this.debounceTime = 200;
        _this.maxSuggestionsNumber = 10;
        _this.loaded = new EventEmitter();
        _this.showTSMO = false;
        _this.showZipCodes = false;
        _this.selectedZip = '';
        _this.loading = false;
        _this._selections = [];
        _this.hasSelectionChange = new EventEmitter();
        _this.hideRegionSearch = false;
        _this.showPenndotLabel = false;
        _this.activePicker = new FormControl('county');
        _this.searchText = new FormControl('');
        _this.setDefaults = new FormControl(false);
        _this.searchResults = [];
        _this.hasDefaultSelection$ = new BehaviorSubject(false);
        _this.isFetchingUserSettings = false;
        _this.activate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isFetchingUserSettings) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadUserSettings()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.setDefaults.setValue(false);
                        this.hasSelectionChange.emit(!!this.selection || this.selections.length > 0);
                        if (this.isActive) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.loadData(this.activePicker.value)];
                    case 3:
                        _a.sent();
                        this.isActive = true;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.reset = function () {
            _this.selection = null;
            _this.selections = [];
            _this.selectedCounty = null;
        };
        _this.addResultToMap = function () {
            if (_this.activePicker.value === 'zipCodes') {
                _this.selections = [{ type: 'zipCode', zip: _this.selectedZip, title: _this.selectedZip }];
            }
            if (!_this.selections || _this.selections.length === 0) {
                return;
            }
            _this.aoiService.setSearchCriterias(_this.selections);
            if (_this.setDefaults.value) {
                _this.setDefaultSelection();
            }
        };
        return _this;
    }
    Object.defineProperty(RegionComponent.prototype, "AoiService", {
        get: function () {
            return this.aoiService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionComponent.prototype, "canSaveDefaultSelection", {
        get: function () {
            return this.SUPPORTED_DEFAULT_REGIONS.includes(this.activePicker.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionComponent.prototype, "selection", {
        get: function () {
            return this._selection;
        },
        set: function (value) {
            this._selection = value;
            this.hasSelectionChange.emit(!!value);
            if (this.searchText.value.length > 0) {
                this.populateSearchResults(this.searchText.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionComponent.prototype, "selections", {
        get: function () {
            return this._selections;
        },
        set: function (value) {
            this._selections = value;
            this.hasSelectionChange.emit(value && value.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    RegionComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.activePicker.valueChanges.subscribe(function (_) {
            _this.selections = [];
            _this.setDefaults.setValue(false);
            _this.cdr.detectChanges();
        });
        this.authService.permissions.subscribe(function (permissions) {
            _this.showTSMO = permissions
                && (permissions.includes('TSMO Layers')
                    || permissions.includes('TSMO Non-Restricted Data')
                    || permissions.includes('TSMO Restricted Data')
                    || permissions.includes('TSMO Data'));
        });
        this.searchText.valueChanges.pipe(debounceTime(this.debounceTime), distinctUntilChanged()).subscribe(function (text) {
            _this.populateSearchResults(text);
        });
        this.authService.GetCurrentUser().subscribe(function (user) {
            if (user) {
                _this.currentUser = user;
                if (_this.isActive) {
                    _this.loadUserSettings();
                }
            }
            else {
                _this.currentUser = null;
                _this.userSettings = null;
                _this.hasDefaultSelection$.next(false);
            }
        });
        this.isReady();
    };
    RegionComponent.prototype.loadUserSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parentScope, _a, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.currentUser) {
                            return [2 /*return*/];
                        }
                        this.isFetchingUserSettings = true;
                        if (!!this.userSettingsComponent) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getClosestAncestor('mc-scope')];
                    case 1:
                        parentScope = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        _a = this;
                        return [4 /*yield*/, parentScope.getComponent('mc-user-settings')];
                    case 3:
                        _a.userSettingsComponent = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        return [2 /*return*/];
                    case 5:
                        this.userSettingsService.GetSettingValue('userSettings', environment.pdauthAppName, this.currentUser.emailAddress).pipe(take(1)).subscribe(function (settings) {
                            _this.userSettings = settings;
                            _this.isFetchingUserSettings = false;
                            _this.hasDefaultSelection$.next(settings.counties && settings.counties.length > 0
                                || settings.districts && settings.districts.length > 0);
                            _this.cdr.detectChanges();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RegionComponent.prototype.loadData = function (region) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, args, regionIndex_1, returnMapping_1, regionRequests, error_2;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (!region) {
                            region = this.activePicker.value;
                        }
                        args = [
                            { regionName: 'district', val: 0 },
                            { regionName: 'county', val: 1 },
                            { regionName: 'municipality', val: 2 },
                            { regionName: 'planningPartner', val: 3 },
                            { regionName: 'houseDistrict', val: 4 },
                            { regionName: 'senateDistrict', val: 5 },
                            { regionName: 'congressionalDistrict', val: 6 },
                            { regionName: 'zipCode', val: 7 },
                            { regionName: 'schoolDistrict', val: 8 }
                        ];
                        args = args.filter(function (reg) { return reg.regionName === region; });
                        if (this.checkIfLoaded(args[0].regionName)) {
                            return [2 /*return*/]; //data is already loaded
                        }
                        regionIndex_1 = args[0].val;
                        returnMapping_1 = [
                            (function (d) { return (tslib_1.__assign({ type: 'district', title: "District " + d.districtNumber }, d)); }),
                            (function (c) { return (tslib_1.__assign({ type: 'county', title: c.name + " COUNTY (" + c.countyCode + ")" }, c)); }),
                            (function (m) { return (tslib_1.__assign({ type: 'municipality', title: m.name + " " + (m.municipalityClass ? m.municipalityClass.includes('TWP') ? 'TOWNSHIP' : m.municipalityClass.toUpperCase() : '') + " (" + m.municipalityCode + ")" }, m)); }),
                            (function (p) { return (tslib_1.__assign({ type: 'planningPartner', title: (p.agencyType ? p.agencyType.toUpperCase() : '') + ": " + p.planningPartnerShortName }, p)); }),
                            (function (h) { return (tslib_1.__assign({ type: 'houseDistrict', title: h.lastName + " " + h.firstName + " (District " + h.houseDistrictNumber + ")" }, h)); }),
                            (function (s) { return (tslib_1.__assign({ type: 'senateDistrict', title: s.lastName + " " + s.firstName + " (District " + s.senateDistrictNumber + ")" }, s)); }),
                            (function (c) { return (tslib_1.__assign({ type: 'congressionalDistrict', title: c.lastName + " " + c.firstName + " (District " + c.congressionalDistrictNumber + ")" }, c)); }),
                            (function (z) { return (tslib_1.__assign({ type: 'zipCode', title: "" + z.zipCode }, z)); }),
                            (function (sd) { return (tslib_1.__assign({ type: 'schoolDistrict', title: "" + sd.schoolDistrictName }, sd)); })
                        ];
                        regionRequests = [];
                        switch (region) {
                            case 'district':
                                regionRequests.push(this.gisToolsService.getAllDistricts('districtNumber'));
                                break;
                            case 'county':
                                regionRequests.push(this.gisToolsService.getAllCounties('countyCode, paCtyCode, name', this.countySortField));
                                break;
                            case 'municipality':
                                regionRequests.push(this.gisToolsService.getAllMunicipalities('countyCode, municipalityCode, municipalityClass, name'));
                                break;
                            case 'planningPartner':
                                regionRequests.push(this.gisToolsService.getAllPlanningPartners('planningPartnerShortName, agencyType'));
                                break;
                            case 'houseDistrict':
                                regionRequests.push(this.gisToolsService.getAllHouseDistricts('firstName, lastName, legislativeDistrictNumber'));
                                break;
                            case 'senateDistrict':
                                regionRequests.push(this.gisToolsService.getAllSenateDistricts('firstName, lastName, legislativeDistrictNumber'));
                                break;
                            case 'congressionalDistrict':
                                regionRequests.push(this.gisToolsService.getAllCongressionalDistricts('firstName, lastName, legislativeDistrictNumber'));
                                break;
                            case 'zipCode':
                                regionRequests.push(this.gisToolsService.getAllZipCodes('zip'));
                                break;
                            case 'schoolDistrict':
                                regionRequests.push(this.gisToolsService.getAllSchoolDistricts('countyCode,schoolDistrictName'));
                                break;
                            default:
                                break;
                        }
                        return [4 /*yield*/, Promise.all(regionRequests).then(function (results) {
                                for (var i = 0; i < returnMapping_1.length; i++) {
                                    if (i !== regionIndex_1) {
                                        switch (i) {
                                            case 0:
                                                results.splice(i, 0, _this.districts);
                                                break;
                                            case 1:
                                                results.splice(i, 0, _this.counties);
                                                break;
                                            case 2:
                                                results.splice(i, 0, _this.municipalities);
                                                break;
                                            case 3:
                                                results.splice(i, 0, _this.planningPartners);
                                                break;
                                            case 4:
                                                results.splice(i, 0, _this.houseDistricts);
                                                break;
                                            case 5:
                                                results.splice(i, 0, _this.senateDistricts);
                                                break;
                                            case 6:
                                                results.splice(i, 0, _this.congressionalDistricts);
                                                break;
                                            case 7:
                                                results.splice(i, 0, _this.zipCodes);
                                                break;
                                            case 8:
                                                results.splice(i, 0, _this.schoolDistricts);
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                }
                                return results.map(function (result) {
                                    return result ? result.map(returnMapping_1[regionIndex_1]) : undefined;
                                });
                            })];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 9]), this.districts = _a[0], this.counties = _a[1], this.municipalities = _a[2], this.planningPartners = _a[3], this.houseDistricts = _a[4], this.senateDistricts = _a[5], this.congressionalDistricts = _a[6], this.zipCodes = _a[7], this.schoolDistricts = _a[8];
                        this.tsmoRegions = environment.tsmoRegions;
                        this.loaded.emit([this.districts, this.counties, this.municipalities, this.planningPartners, this.houseDistricts, this.senateDistricts, this.congressionalDistricts]);
                        this.hasSelectionChange.emit(false);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        this.loggingService.Log('Error retrieving AOI filter data', error_2);
                        return [3 /*break*/, 3];
                    case 3:
                        this.cdr.detectChanges();
                        if (region === 'municipality' && this.counties && this.selectedCounty === undefined) {
                            this.selectedCounty = this.counties[0];
                            this.filterMunicipalities(this.selectedCounty);
                        }
                        if (region === 'schoolDistrict' && this.counties && this.selectedSchoolCounty === undefined) {
                            this.selectedSchoolCounty = this.counties[0];
                            this.filterSchoolDistrict(this.selectedSchoolCounty);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RegionComponent.prototype.addSelectionFromSearch = function (selection) {
        this.addSelection(selection);
        this.searchText.setValue('');
    };
    RegionComponent.prototype.addSelection = function (selection) {
        this.selection = selection;
        this.selections.push(selection);
        var flags = {};
        this.selections = this.selections.filter(function (s) {
            if (flags[s.title]) {
                return false;
            }
            flags[s.title] = true;
            return true;
        });
    };
    /**
     * Selects a region tab and sets its default selections.
     * @param region The region tab to make selections in.
     * @returns True if the region tab is supported and has default selections. Otherwise, returns false.
     */
    RegionComponent.prototype.useDefaultSelectionForRegion = function (region) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var defaultSelections, items, getItemCode;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadData(region)];
                    case 1:
                        _a.sent();
                        switch (region) {
                            case 'district':
                                defaultSelections = this.userSettings.districts;
                                items = this.districts;
                                getItemCode = function (d) { return d.districtNumber; };
                                break;
                            case 'county':
                                defaultSelections = this.userSettings.counties;
                                items = this.counties;
                                getItemCode = function (c) { return c.countyCode; };
                                break;
                            default:
                                return [2 /*return*/, false];
                        }
                        if (!defaultSelections || defaultSelections.length === 0) {
                            return [2 /*return*/, false];
                        }
                        this.activePicker.setValue(region);
                        defaultSelections = defaultSelections.map(function (x) { return x.split('-')[1]; });
                        this.selections = items.filter(function (x) { return defaultSelections.includes(getItemCode(x)); });
                        return [2 /*return*/, true];
                }
            });
        });
    };
    RegionComponent.prototype.useDefaultSelection = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, regions, regions_1, regions_1_1, region, e_1_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        regions = this.SUPPORTED_DEFAULT_REGIONS.slice();
                        // Try to load the default selections for the currently selected tab first.
                        // The first region with default selections is the one we go with.
                        regions.unshift(this.activePicker.value);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        regions_1 = tslib_1.__values(regions), regions_1_1 = regions_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!regions_1_1.done) return [3 /*break*/, 5];
                        region = regions_1_1.value;
                        return [4 /*yield*/, this.useDefaultSelectionForRegion(region)];
                    case 3:
                        if (_b.sent()) {
                            return [3 /*break*/, 5];
                        }
                        _b.label = 4;
                    case 4:
                        regions_1_1 = regions_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (regions_1_1 && !regions_1_1.done && (_a = regions_1.return)) _a.call(regions_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RegionComponent.prototype.setDefaultSelection = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.userSettings) {
                            this.userSettings = {};
                        }
                        switch (this.activePicker.value) {
                            case 'district':
                                this.userSettings.districts = this.selections.map(function (x) { return "district-" + x.districtNumber; });
                                break;
                            case 'county':
                                this.userSettings.counties = this.selections.map(function (x) { return "county-" + x.countyCode; });
                                break;
                            default:
                                return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.userSettingsService.SetSettingValue('userSettings', this.userSettings, this.currentUser.emailAddress, environment.pdauthAppName)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegionComponent.prototype.removeSelection = function (selection) {
        this.selections = this.selections.filter(function (s) { return s !== selection; });
        if (this.selections.length === 0) {
            this.selection = null;
        }
    };
    RegionComponent.prototype.filterMunicipalities = function (county) {
        this.selection = null;
        this.selections = [];
        if (!this.checkIfLoaded('municipality')) {
            this.loadData('municipality');
        }
        this.filteredMunicipalties = this.municipalities.filter(function (m) { return m.countyCode === county.countyCode; });
        this.selectedCounty = county;
    };
    RegionComponent.prototype.filterSchoolDistrict = function (county) {
        this.selection = null;
        this.selections = [];
        if (!this.checkIfLoaded('schoolDistrict')) {
            this.loadData('schoolDistrict');
        }
        this.filteredschoolDistricts = this.schoolDistricts.filter(function (sd) { return sd.countyCode === county.paCtyCode; });
        this.selectedSchoolCounty = county;
    };
    RegionComponent.prototype.populateSearchResults = function (text) {
        var _this = this;
        if (!text) {
            this.searchResults = [];
            this.omitted = 0;
            return;
        }
        this.searchResults = [
            this.districts,
            this.counties,
            this.municipalities,
            this.planningPartners,
            this.senateDistricts,
            this.houseDistricts,
            this.congressionalDistricts
        ].flat()
            .filter(function (r) { return r && r.title && r.title.toLowerCase().includes(text.toLowerCase()); });
        if (this.selections.length > 0) {
            this.searchResults = this.searchResults.filter(function (r) { return r.type === _this.selections[0].type; });
        }
        if (this.searchResults.length > this.maxSuggestionsNumber + 1) {
            this.omitted = this.searchResults.length - this.maxSuggestionsNumber;
            this.searchResults = this.searchResults.slice(0, this.maxSuggestionsNumber);
        }
    };
    RegionComponent.prototype.checkIfLoaded = function (region) {
        switch (region) {
            case 'district':
                return this.districts && this.districts.length > 0;
            case 'county':
                return this.counties && this.counties.length > 0;
            case 'municipality':
                return this.municipalities && this.municipalities.length > 0;
            case 'planningPartner':
                return this.planningPartners && this.planningPartners.length > 0;
            case 'houseDistrict':
                return this.houseDistricts && this.houseDistricts.length > 0;
            case 'senateDistrict':
                return this.senateDistricts && this.senateDistricts.length > 0;
            case 'congressionalDistrict':
                return this.congressionalDistricts && this.congressionalDistricts.length > 0;
            case 'zipCode':
                return this.zipCodes && this.zipCodes.length > 0;
            case 'schoolDistrict':
                return this.schoolDistricts && this.schoolDistricts.length > 0;
            default:
                return false;
        }
    };
    return RegionComponent;
}(BaseComponent));
export { RegionComponent };
